import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'bright-lilac',
  name: 'Bright lilac',
  palette: {
    primary: '#4137ED',
    accent: '#6A2AED',
    neutral: '#F7F7FD',
  },
  light1: {
    'action-primary': '#4f46f0',
    'action-primary-hovered': '#766ff8',
    'action-primary-pressed': '#6946f0',
    'action-primary-subdued': '#e9e8ff',
    'action-primary-subdued-hovered': '#f3f2ff',
    'action-primary-subdued-pressed': '#dcdaff',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f1f0ff',
    'action-neutral-pressed': '#edebff',
    'action-neutral-subdued': '#f2f2f2',
    'action-neutral-subdued-hovered': '#e6e6e6',
    'action-neutral-subdued-pressed': '#d4d4d4',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#F8F8FE',
    'background-hovered': '#fffefe',
    'background-pressed': '#ffffff',
    'background-selected': '#e1d9fa',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#1a1c20',
    'content-subdued': '#3a3d42',
    'content-muted': '#5b5e66',
    'content-hovered': '#26292f',
    'content-pressed': '#535353',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#6f5ef1',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f7f7',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1a1c20',
    'content-on-background-subdued': '#403b5b',
    'content-on-background-hovered': '#26292f',
    'content-on-background-pressed': '#766ff8',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#773cf1',
    'interactive-hovered': '#675bf0',
    'interactive-pressed': '#372da2',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f7f7f7',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f3f2ff',
    'content-on-topbar': '#060606',
    'line-on-topbar': '#d4d4d4',
    'line-on-topbar-pressed': '#bcb9ff',
    link: '#2f0eed',
    'link-hovered': '#6c4af3',
    'link-pressed': '#240cac',
    line: '#d4d4d4',
    'line-subdued': '#f2f6fc',
    'line-hovered': '#d1d0ea',
    'line-pressed': '#c3c2da',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#372da2',
    skeleton: '#f3f2ff',
    surface: '#FFFFFF',
    'surface-subdued': '#F8F8FE',
    'surface-hovered': '#f4f2fc',
    'surface-subdued-hovered': '#fcfeff',
    'surface-pressed': '#f3f0ff',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f3f1fd',
    'surface-selected-hovered': '#f6f5ff',
    'surface-selected-pressed': '#ece8ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#F8F8FE',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#4f46f0',
    'action-primary-hovered': '#766ff8',
    'action-primary-pressed': '#6946f0',
    'action-primary-subdued': '#e9e8ff',
    'action-primary-subdued-hovered': '#f3f2ff',
    'action-primary-subdued-pressed': '#dcdaff',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f6f5ff',
    'action-neutral-pressed': '#eceaff',
    'action-neutral-subdued': '#f2f2f2',
    'action-neutral-subdued-hovered': '#e6e6e6',
    'action-neutral-subdued-pressed': '#d4d4d4',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#FFFFFF',
    'background-hovered': '#f7f6fe',
    'background-pressed': '#F8F8FE',
    'background-selected': '#e5ebf3',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#1a1c20',
    'content-subdued': '#3a3d42',
    'content-muted': '#727272',
    'content-hovered': '#26292f',
    'content-pressed': '#535353',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#6f5ef1',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f7f7',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1a1c20',
    'content-on-background-subdued': '#535353',
    'content-on-background-hovered': '#26292f',
    'content-on-background-pressed': '#766ff8',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#773cf1',
    'interactive-hovered': '#675bf0',
    'interactive-pressed': '#372da2',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f7f7f7',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f3f2ff',
    'content-on-topbar': '#060606',
    'line-on-topbar': '#d4d4d4',
    'line-on-topbar-pressed': '#c5c3f2',
    link: '#2f0eed',
    'link-hovered': '#6c4af3',
    'link-pressed': '#240cac',
    line: '#d4d4d4',
    'line-subdued': '#e7e7f3',
    'line-hovered': '#dad9e6',
    'line-pressed': '#c5c4d0',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#372da2',
    skeleton: '#f3f2ff',
    surface: '#FFFFFF',
    'surface-subdued': '#F8F8FE',
    'surface-hovered': '#f4f2fc',
    'surface-subdued-hovered': '#fcfeff',
    'surface-pressed': '#f3f0ff',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f3f1fd',
    'surface-selected-hovered': '#f6f5ff',
    'surface-selected-pressed': '#ece8ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#F8F8FE',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#4f46f0',
    'action-primary-hovered': '#766ff8',
    'action-primary-pressed': '#6946f0',
    'action-primary-subdued': '#e9e8ff',
    'action-primary-subdued-hovered': '#f3f2ff',
    'action-primary-subdued-pressed': '#dcdaff',
    'action-primary-disabled': '#f7f7f7',
    'action-neutral': '#ffffff',
    'action-neutral-hovered': '#f6f5ff',
    'action-neutral-pressed': '#eceaff',
    'action-neutral-subdued': '#e6e6e6',
    'action-neutral-subdued-hovered': '#d4d4d4',
    'action-neutral-subdued-pressed': '#d4d4d4',
    'action-neutral-disabled': '#f7f7f7',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f2f2f2',
    background: '#FFFFFF',
    'background-hovered': '#f8f6ff',
    'background-pressed': '#f3f1ff',
    'background-selected': '#e9e6f5',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a1a1a1',
    content: '#1a1c20',
    'content-subdued': '#3a3d42',
    'content-muted': '#5b5e66',
    'content-hovered': '#26292f',
    'content-pressed': '#535353',
    'content-disabled': '#a1a1a1',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00294b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#6f5ef1',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f7f7f7',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#1a1c20',
    'content-on-background-subdued': '#403b5b',
    'content-on-background-hovered': '#26292f',
    'content-on-background-pressed': '#766ff8',
    'content-on-background-disabled': '#a1a1a1',
    interactive: '#773cf1',
    'interactive-hovered': '#675bf0',
    'interactive-pressed': '#372da2',
    'interactive-disabled': '#f7f7f7',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f7f7f7',
    topbar: '#f3f2ff',
    'topbar-subdued': '#efeefc',
    'content-on-topbar': '#060606',
    'line-on-topbar': '#d4d4d4',
    'line-on-topbar-pressed': '#bcb9ff',
    link: '#2f0eed',
    'link-hovered': '#6c4af3',
    'link-pressed': '#240cac',
    line: '#d4d4d4',
    'line-subdued': '#f2f6fc',
    'line-hovered': '#d1d0ea',
    'line-pressed': '#c3c2da',
    'line-selected': '#535353',
    'line-disabled': '#e6e6e6',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005791',
    'line-highlight-subdued': '#a5dbff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#372da2',
    skeleton: '#f3f2ff',
    surface: '#F8F8FE',
    'surface-subdued': '#F8F8FE',
    'surface-hovered': '#ffffff',
    'surface-subdued-hovered': '#fcfeff',
    'surface-pressed': '#f3f0ff',
    'surface-disabled': '#f7f7f7',
    'surface-selected': '#f3f1fd',
    'surface-selected-hovered': '#f6f5ff',
    'surface-selected-pressed': '#ece8ff',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#cdebff',
    'surface-highlight-subdued': '#f0f8ff',
    'surface-highlight-subdued-hovered': '#e6f5ff',
    'surface-highlight-subdued-pressed': '#cdebff',
    'surface-neutral': '#F8F8FE',
    'surface-neutral-subdued': '#f7f7f7',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#4f46f0',
    'action-primary-hovered': '#766ff8',
    'action-primary-pressed': '#6946f0',
    'action-primary-subdued': '#313141',
    'action-primary-subdued-hovered': '#31353c',
    'action-primary-subdued-pressed': '#20202a',
    'action-primary-disabled': '#404040',
    'action-neutral': '#19191f',
    'action-neutral-hovered': '#2a2a34',
    'action-neutral-pressed': '#31303b',
    'action-neutral-subdued': '#191a1f',
    'action-neutral-subdued-hovered': '#454552',
    'action-neutral-subdued-pressed': '#3a3a3d',
    'action-neutral-disabled': '#404040',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#404040',
    background: '#15151a',
    'background-hovered': '#20202a',
    'background-pressed': '#2c3053',
    'background-selected': '#242744',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#2a2d32',
    content: '#fcfcff',
    'content-subdued': '#dbdbf3',
    'content-muted': '#a1a1a1',
    'content-hovered': '#f8f9ff',
    'content-pressed': '#d4d4d4',
    'content-disabled': '#727272',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#ffffff',
    'content-on-primary': '#f6f9ff',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f7f7f7',
    'content-on-interactive': '#fcfcff',
    'content-on-background': '#fcfcff',
    'content-on-background-subdued': '#edeefb',
    'content-on-background-hovered': '#f6f9ff',
    'content-on-background-pressed': '#e5e7ff',
    'content-on-background-disabled': '#727272',
    interactive: '#773cf1',
    'interactive-hovered': '#675bf0',
    'interactive-pressed': '#372da2',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#15171a',
    'topbar-subdued': '#1A1D21',
    'content-on-topbar': '#f7f7f7',
    'line-on-topbar': '#3b3c3f',
    'line-on-topbar-pressed': '#46468d',
    link: '#6b6bff',
    'link-hovered': '#8f8fff',
    'link-pressed': '#5f5fde',
    line: '#383840',
    'line-subdued': '#22222f',
    'line-hovered': '#22222f',
    'line-pressed': '#1c1c27',
    'line-selected': '#515158',
    'line-disabled': '#404040',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#7d7dff',
    skeleton: '#2a2b3b',
    surface: '#1b1b24',
    'surface-subdued': '#292937',
    'surface-hovered': '#22222a',
    'surface-subdued-hovered': '#30303c',
    'surface-pressed': '#363641',
    'surface-disabled': '#404040',
    'surface-selected': '#383c5b',
    'surface-selected-hovered': '#3d444f',
    'surface-selected-pressed': '#2b313a',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#22242c',
    'surface-neutral-subdued': '#333439',
    'surface-inverse': '#f6f9ff',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#4f46f0',
    'action-primary-hovered': '#766ff8',
    'action-primary-pressed': '#6946f0',
    'action-primary-subdued': '#272734',
    'action-primary-subdued-hovered': '#313141',
    'action-primary-subdued-pressed': '#20202a',
    'action-primary-disabled': '#404040',
    'action-neutral': '#19191f',
    'action-neutral-hovered': '#2a2a34',
    'action-neutral-pressed': '#31303b',
    'action-neutral-subdued': '#191a1f',
    'action-neutral-subdued-hovered': '#454552',
    'action-neutral-subdued-pressed': '#3a3a3d',
    'action-neutral-disabled': '#282828',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#404040',
    background: '#1b1b24',
    'background-hovered': '#2a2a3a',
    'background-pressed': '#2c3053',
    'background-selected': '#212346',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#2a2d32',
    content: '#fbfbff',
    'content-subdued': '#dbdbf3',
    'content-muted': '#a1a1a1',
    'content-hovered': '#f8f9ff',
    'content-pressed': '#d4d4d4',
    'content-disabled': '#727272',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f4f9fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#ffffff',
    'content-on-primary': '#f6f9ff',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f7f7f7',
    'content-on-interactive': '#fcfcff',
    'content-on-background': '#fcfcff',
    'content-on-background-subdued': '#edeefb',
    'content-on-background-hovered': '#fbfcff',
    'content-on-background-pressed': '#e5e7ff',
    'content-on-background-disabled': '#727272',
    interactive: '#773cf1',
    'interactive-hovered': '#675bf0',
    'interactive-pressed': '#372da2',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#15151a',
    'topbar-subdued': '#0e0e12',
    'content-on-topbar': '#f7f7f7',
    'line-on-topbar': '#3b3c3f',
    'line-on-topbar-pressed': '#46468d',
    link: '#6b6bff',
    'link-hovered': '#8f8fff',
    'link-pressed': '#5f5fde',
    line: '#383840',
    'line-subdued': '#22222f',
    'line-hovered': '#090912',
    'line-pressed': '#010102',
    'line-selected': '#515158',
    'line-disabled': '#404040',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#041828',
    'line-highlight-subdued': '#041828',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#7d7dff',
    skeleton: '#2a2b3b',
    surface: '#15151a',
    'surface-subdued': '#292937',
    'surface-hovered': '#22222a',
    'surface-subdued-hovered': '#30303c',
    'surface-pressed': '#22222d',
    'surface-disabled': '#282828',
    'surface-selected': '#383c5b',
    'surface-selected-hovered': '#3d444f',
    'surface-selected-pressed': '#2b313a',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#092a42',
    'surface-highlight-subdued': '#154365',
    'surface-highlight-subdued-hovered': '#1f5880',
    'surface-highlight-subdued-pressed': '#1f5880',
    'surface-neutral': '#22242c',
    'surface-neutral-subdued': '#333439',
    'surface-inverse': '#f7f7f7',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
